module.exports = __webpack_public_path__ + "img/dark-theme.99043590.svg";